import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";
import TutorModel from "../../models/TutorModel";
import { ApiCommonParams } from "../../@types/apiTypes";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

// @param filters: object
// example:
// {gender: male}
export function indexLiaisonTutors(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/liaisons/tutors`, { params: params });
}
export function showLiaisonTutor(
  tutorId: number | string
): Promise<TutorModel> {
  return Axios.get(`v1/liaisons/tutors/${tutorId}`).then(
    ({ data }: ApiResponse) => TutorModel.fromApiResponse(data)
  );
}
